import { SelectItem } from '@wui/common-library'
import { ConferenceMember, ConferenceType } from '@wui/im'
import { computed, ComputedRef, ref, Ref, watch } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { Contact } from '@/shared/types/api'


export const useCreateRoomOptions = (contacts: ComputedRef<Contact[]>) => {
  const { t } = useLocalization()
  const selectedRoomType: Ref<ConferenceType> = ref(ConferenceType.FREE_FOR_ALL)

  const isModerated: ComputedRef<boolean> = computed(() => {
    return selectedRoomType.value === ConferenceType.MODERATED
  })

  const selectedSubscribers: Ref<ConferenceMember[]> = ref([])
  const needToConfirmEnter: Ref<boolean> = ref(false)
  const needToEnterPinCode: Ref<boolean> = ref(false)

  const contactsList = computed(() => contacts.value.map((contact: Contact) => ({
    label: contact.name,
    value: contact.internalNumber,
  })))
  const roomTypes: ComputedRef<SelectItem[]> = computed(() => [
    {
      label: t('common.creatingRegularChat'),
      value: ConferenceType.FREE_FOR_ALL,
      default: true,
    },
    {
      label: t('common.creatingModeratedChat'),
      value: ConferenceType.MODERATED,
    },
  ])

  const typeOfRoomPlaceholder: ComputedRef<string> = computed(() => {
    return t('common.typeOfRoom')
  })

  const selectedModeratorsPlaceholder: ComputedRef<string> = computed(() => {
    return t('common.selectedModerators')
  })

  const necessityOfConfirmEnterPlaceholder: ComputedRef<string> = computed(() => {
    return t('common.necessaryToConfirmEnter')
  })

  const needToEnterPinCodePlaceholder: ComputedRef<string> = computed(() => {
    return t('common.necessaryToEnterPinCode')
  })

  watch(() => isModerated.value, (newValue: boolean) => {
    if (!newValue) {
      selectedSubscribers.value = selectedSubscribers.value.filter(subscriber => subscriber.role !== 'Moderator')
      needToConfirmEnter.value = false
      needToEnterPinCode.value = false
    }
  })

  return {
    roomTypes,
    selectedRoomType,
    typeOfRoomPlaceholder,
    isModerated,
    contactsList,
    selectedModeratorsPlaceholder,
    necessityOfConfirmEnterPlaceholder,
    needToConfirmEnter,
    selectedSubscribers,
    needToEnterPinCode,
    needToEnterPinCodePlaceholder,
  }
}
